module.exports = __webpack_public_path__ + "img/art-21.ae0aee90.png";